export default "__VITE_ASSET__CkqcPiLC__"